import { Card, Divider, Grid, Layout, Space, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';

import {
  useOrganization,
  useOrganizationSettings,
} from '../../components/OrganizationProvider';
import paths from '../../paths.json';

import ChangePasswordForm from './ChangePasswordForm';
import ErrorAlert from './ErrorAlert';
import LoginForm from './LoginForm';
import ResetPasswordForm from './ResetPasswordForm';
import styles from './styles.module.less';
import SuccessAlert from './SuccessAlert';

const year = new Date().getFullYear();
const Welcome = () => {
  const screens = Grid.useBreakpoint();
  const { legalEntity, name } = useOrganization();
  const { logoUrl, brandmarkUrl } = useOrganizationSettings();
  const history = useHistory();
  const { search, ...location } = useLocation<{
    success: string;
    error: string;
  }>();
  const [success, setSuccess] = useState<string | undefined>();
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    if (location?.state?.success) {
      setSuccess(location?.state?.success);
    }
  }, [setSuccess, location?.state?.success]);

  useEffect(() => {
    if (location?.state?.error) {
      setError(location?.state?.error);
    }
  }, [setSuccess, location?.state?.error]);

  useEffect(() => {
    if (error || success) {
      history.replace({ search, state: undefined });
    }
  }, [error, success, history, search]);

  return (
    <Layout.Content className={styles.layout}>
      <div className={styles.header}>
        {logoUrl && <img alt="logo" className={styles.logo} src={logoUrl} />}
        {!logoUrl && name && (
          <Space align="center" direction="horizontal" size="large">
            {brandmarkUrl && (
              <img alt="logo" className={styles.logo} src={brandmarkUrl} />
            )}
            <Typography.Text className={styles.company}>{name}</Typography.Text>
          </Space>
        )}
      </div>
      <Card className={styles.card} data-test="login">
        {success && <SuccessAlert message={success} />}
        {error && <ErrorAlert message={error} />}
        <Switch>
          <Route path={paths.login}>
            <LoginForm />
          </Route>
          <Route path={paths.changePassword}>
            <ChangePasswordForm />
          </Route>
          <Route path={paths.resetPassword}>
            <ResetPasswordForm />
          </Route>
        </Switch>
      </Card>
      <Space
        align="center"
        className={styles.footer}
        direction={screens.xs ? 'vertical' : 'horizontal'}
        size={screens.xs ? 4 : 0}
        split={!screens.xs && <Divider type="vertical" />}
      >
        <Typography.Text type="secondary">Advertiser Platform</Typography.Text>
        <Typography.Text type="secondary">
          Copyright © {year} {legalEntity}
        </Typography.Text>
      </Space>
    </Layout.Content>
  );
};

Welcome.displayName = 'Welcome';

export default Welcome;
